// Generated by scripts/generate-sprite-metrics.mjs. Do not edit by hand.
import type { Direction, TankEntity } from './types';

export interface SpriteFrameMetrics {
  cellWidth: number;
  cellHeight: number;
  bounds: { x: number; y: number; width: number; height: number };
  centerOffset: { x: number; y: number };
  muzzleLateralOffset: number;
}

export type SpriteMetricKey = keyof typeof SPRITE_METRICS;

export const SPRITE_METRICS = {
  "p1": {
    "up": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 59,
        "y": 0,
        "width": 162,
        "height": 241
      },
      "centerOffset": {
        "x": 0,
        "y": -19.5
      },
      "muzzleLateralOffset": 0
    },
    "right": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 67,
        "y": 66,
        "width": 188,
        "height": 149
      },
      "centerOffset": {
        "x": 21,
        "y": 0.5
      },
      "muzzleLateralOffset": -9
    },
    "down": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 59,
        "y": 60,
        "width": 163,
        "height": 194
      },
      "centerOffset": {
        "x": 0.5,
        "y": 17
      },
      "muzzleLateralOffset": 0.5
    },
    "left": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 25,
        "y": 66,
        "width": 188,
        "height": 149
      },
      "centerOffset": {
        "x": -21,
        "y": 0.5
      },
      "muzzleLateralOffset": -9
    }
  },
  "p2": {
    "up": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 58,
        "y": 0,
        "width": 164,
        "height": 244
      },
      "centerOffset": {
        "x": 0,
        "y": -18
      },
      "muzzleLateralOffset": -3
    },
    "right": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 67,
        "y": 66,
        "width": 200,
        "height": 149
      },
      "centerOffset": {
        "x": 27,
        "y": 0.5
      },
      "muzzleLateralOffset": -7.5
    },
    "down": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 58,
        "y": 60,
        "width": 164,
        "height": 200
      },
      "centerOffset": {
        "x": 0,
        "y": 20
      },
      "muzzleLateralOffset": 0
    },
    "left": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 13,
        "y": 66,
        "width": 200,
        "height": 149
      },
      "centerOffset": {
        "x": -27,
        "y": 0.5
      },
      "muzzleLateralOffset": -7.5
    }
  },
  "light": {
    "up": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 65,
        "y": 31,
        "width": 150,
        "height": 201
      },
      "centerOffset": {
        "x": 0,
        "y": -8.5
      },
      "muzzleLateralOffset": -5.5
    },
    "right": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 50,
        "y": 65,
        "width": 202,
        "height": 150
      },
      "centerOffset": {
        "x": 11,
        "y": 0
      },
      "muzzleLateralOffset": -4.5
    },
    "down": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 65,
        "y": 48,
        "width": 150,
        "height": 201
      },
      "centerOffset": {
        "x": 0,
        "y": 8.5
      },
      "muzzleLateralOffset": 5.5
    },
    "left": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 28,
        "y": 65,
        "width": 202,
        "height": 150
      },
      "centerOffset": {
        "x": -11,
        "y": 0
      },
      "muzzleLateralOffset": -4.5
    }
  },
  "assault": {
    "up": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 65,
        "y": 29,
        "width": 150,
        "height": 210
      },
      "centerOffset": {
        "x": 0,
        "y": -6
      },
      "muzzleLateralOffset": -2.12
    },
    "right": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 41,
        "y": 65,
        "width": 210,
        "height": 150
      },
      "centerOffset": {
        "x": 6,
        "y": 0
      },
      "muzzleLateralOffset": -2.12
    },
    "down": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 65,
        "y": 41,
        "width": 150,
        "height": 210
      },
      "centerOffset": {
        "x": 0,
        "y": 6
      },
      "muzzleLateralOffset": 2.12
    },
    "left": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 29,
        "y": 65,
        "width": 210,
        "height": 150
      },
      "centerOffset": {
        "x": -6,
        "y": 0
      },
      "muzzleLateralOffset": -2.12
    }
  },
  "boss": {
    "up": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 51,
        "y": 0,
        "width": 178,
        "height": 240
      },
      "centerOffset": {
        "x": 0,
        "y": -20
      },
      "muzzleLateralOffset": -1
    },
    "right": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 53,
        "y": 56,
        "width": 227,
        "height": 168
      },
      "centerOffset": {
        "x": 26.5,
        "y": 0
      },
      "muzzleLateralOffset": -4.81
    },
    "down": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 51,
        "y": 49,
        "width": 178,
        "height": 205
      },
      "centerOffset": {
        "x": 0,
        "y": 11.5
      },
      "muzzleLateralOffset": 1
    },
    "left": {
      "cellWidth": 280,
      "cellHeight": 280,
      "bounds": {
        "x": 0,
        "y": 56,
        "width": 227,
        "height": 168
      },
      "centerOffset": {
        "x": -26.5,
        "y": 0
      },
      "muzzleLateralOffset": -4.81
    }
  },
  "heavy": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 21,
        "y": 0,
        "width": 87,
        "height": 112
      },
      "centerOffset": {
        "x": 0.5,
        "y": -8
      },
      "muzzleLateralOffset": 0.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 16,
        "y": 21,
        "width": 112,
        "height": 87
      },
      "centerOffset": {
        "x": 8,
        "y": 0.5
      },
      "muzzleLateralOffset": 0.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 21,
        "y": 16,
        "width": 87,
        "height": 112
      },
      "centerOffset": {
        "x": 0.5,
        "y": 8
      },
      "muzzleLateralOffset": 0.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 0,
        "y": 21,
        "width": 112,
        "height": 87
      },
      "centerOffset": {
        "x": -8,
        "y": 0.5
      },
      "muzzleLateralOffset": 0.5
    }
  },
  "sniper": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 33,
        "y": 0,
        "width": 62,
        "height": 116
      },
      "centerOffset": {
        "x": 0,
        "y": -6
      },
      "muzzleLateralOffset": 0
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 18,
        "y": 36,
        "width": 110,
        "height": 56
      },
      "centerOffset": {
        "x": 9,
        "y": 0
      },
      "muzzleLateralOffset": -1
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 33,
        "y": 15,
        "width": 62,
        "height": 113
      },
      "centerOffset": {
        "x": 0,
        "y": 7.5
      },
      "muzzleLateralOffset": 0
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 0,
        "y": 36,
        "width": 110,
        "height": 56
      },
      "centerOffset": {
        "x": -9,
        "y": 0
      },
      "muzzleLateralOffset": -1
    }
  },
  "upgrade1": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 29,
        "y": 4,
        "width": 70,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 27,
        "width": 120,
        "height": 74
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 29,
        "y": 4,
        "width": 70,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 27,
        "width": 120,
        "height": 74
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0
    }
  },
  "upgrade2": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 27,
        "y": 4,
        "width": 74,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 1
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 26,
        "width": 120,
        "height": 75
      },
      "centerOffset": {
        "x": 0,
        "y": -0.5
      },
      "muzzleLateralOffset": -1.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 27,
        "y": 4,
        "width": 74,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -1
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 26,
        "width": 120,
        "height": 75
      },
      "centerOffset": {
        "x": 0,
        "y": -0.5
      },
      "muzzleLateralOffset": -1.5
    }
  },
  "upgrade3": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 25,
        "y": 4,
        "width": 77,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 27,
        "width": 120,
        "height": 73
      },
      "centerOffset": {
        "x": 0,
        "y": -0.5
      },
      "muzzleLateralOffset": -2
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 26,
        "y": 4,
        "width": 77,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 27,
        "width": 120,
        "height": 73
      },
      "centerOffset": {
        "x": 0,
        "y": -0.5
      },
      "muzzleLateralOffset": -2
    }
  },
  "upgrade4": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 25,
        "y": 4,
        "width": 77,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 1
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 27,
        "width": 120,
        "height": 74
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 26,
        "y": 4,
        "width": 77,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": -1
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 27,
        "width": 120,
        "height": 74
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    }
  },
  "p2upgrade1": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 29,
        "y": 4,
        "width": 70,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 27,
        "width": 120,
        "height": 74
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 29,
        "y": 4,
        "width": 70,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 27,
        "width": 120,
        "height": 74
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0
    }
  },
  "p2upgrade2": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 27,
        "y": 4,
        "width": 74,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 1
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 26,
        "width": 120,
        "height": 75
      },
      "centerOffset": {
        "x": 0,
        "y": -0.5
      },
      "muzzleLateralOffset": -1.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 27,
        "y": 4,
        "width": 74,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -1
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 26,
        "width": 120,
        "height": 75
      },
      "centerOffset": {
        "x": 0,
        "y": -0.5
      },
      "muzzleLateralOffset": -1.5
    }
  },
  "p2upgrade3": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 25,
        "y": 4,
        "width": 77,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 27,
        "width": 120,
        "height": 73
      },
      "centerOffset": {
        "x": 0,
        "y": -0.5
      },
      "muzzleLateralOffset": -2
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 26,
        "y": 4,
        "width": 77,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 27,
        "width": 120,
        "height": 73
      },
      "centerOffset": {
        "x": 0,
        "y": -0.5
      },
      "muzzleLateralOffset": -2
    }
  },
  "p2upgrade4": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 25,
        "y": 4,
        "width": 77,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 1
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 27,
        "width": 120,
        "height": 74
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 26,
        "y": 4,
        "width": 77,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": -1
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 27,
        "width": 120,
        "height": 74
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    }
  },
  "p1-assault-upgrade1": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 30,
        "y": 4,
        "width": 67,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 7,
        "y": 32,
        "width": 114,
        "height": 64
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 31,
        "y": 4,
        "width": 67,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 7,
        "y": 32,
        "width": 114,
        "height": 64
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    }
  },
  "p1-assault-upgrade2": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 31,
        "y": 4,
        "width": 66,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 3.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 7,
        "y": 31,
        "width": 115,
        "height": 66
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 31,
        "y": 4,
        "width": 66,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -3.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 6,
        "y": 31,
        "width": 115,
        "height": 66
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    }
  },
  "p1-assault-upgrade3": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 27,
        "y": 4,
        "width": 73,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 7,
        "y": 30,
        "width": 115,
        "height": 68
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 28,
        "y": 4,
        "width": 73,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 6,
        "y": 30,
        "width": 115,
        "height": 68
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    }
  },
  "p1-assault-upgrade4": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 28,
        "y": 4,
        "width": 71,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 5,
        "y": 29,
        "width": 118,
        "height": 70
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 29,
        "y": 4,
        "width": 71,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 5,
        "y": 29,
        "width": 118,
        "height": 70
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    }
  },
  "p1-heavy-upgrade1": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 23,
        "y": 4,
        "width": 81,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 24,
        "width": 120,
        "height": 80
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -2.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 24,
        "y": 4,
        "width": 81,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 24,
        "width": 120,
        "height": 80
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -2.5
    }
  },
  "p1-heavy-upgrade2": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 23,
        "y": 4,
        "width": 81,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 23,
        "width": 120,
        "height": 81
      },
      "centerOffset": {
        "x": 0,
        "y": -0.5
      },
      "muzzleLateralOffset": -3.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 24,
        "y": 4,
        "width": 81,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 23,
        "width": 120,
        "height": 81
      },
      "centerOffset": {
        "x": 0,
        "y": -0.5
      },
      "muzzleLateralOffset": -3.5
    }
  },
  "p1-heavy-upgrade3": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 23,
        "y": 4,
        "width": 81,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 23,
        "width": 120,
        "height": 82
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -2
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 24,
        "y": 4,
        "width": 81,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 23,
        "width": 120,
        "height": 82
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -2
    }
  },
  "p1-heavy-upgrade4": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 23,
        "y": 4,
        "width": 82,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 1
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 22,
        "width": 120,
        "height": 84
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -1.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 23,
        "y": 4,
        "width": 82,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -1
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 22,
        "width": 120,
        "height": 84
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -1.5
    }
  },
  "p2-assault-upgrade1": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 30,
        "y": 4,
        "width": 67,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 7,
        "y": 32,
        "width": 114,
        "height": 64
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 31,
        "y": 4,
        "width": 67,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 7,
        "y": 32,
        "width": 114,
        "height": 64
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    }
  },
  "p2-assault-upgrade2": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 31,
        "y": 4,
        "width": 66,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 3.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 7,
        "y": 31,
        "width": 115,
        "height": 66
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 31,
        "y": 4,
        "width": 66,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -3.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 6,
        "y": 31,
        "width": 115,
        "height": 66
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    }
  },
  "p2-assault-upgrade3": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 27,
        "y": 4,
        "width": 73,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 7,
        "y": 30,
        "width": 115,
        "height": 68
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 28,
        "y": 4,
        "width": 73,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 6,
        "y": 30,
        "width": 115,
        "height": 68
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    }
  },
  "p2-assault-upgrade4": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 28,
        "y": 4,
        "width": 71,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 5,
        "y": 29,
        "width": 118,
        "height": 70
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 29,
        "y": 4,
        "width": 71,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 5,
        "y": 29,
        "width": 118,
        "height": 70
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    }
  },
  "p2-heavy-upgrade1": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 23,
        "y": 4,
        "width": 81,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 24,
        "width": 120,
        "height": 80
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -2.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 24,
        "y": 4,
        "width": 81,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 24,
        "width": 120,
        "height": 80
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -2.5
    }
  },
  "p2-heavy-upgrade2": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 23,
        "y": 4,
        "width": 81,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 23,
        "width": 120,
        "height": 81
      },
      "centerOffset": {
        "x": 0,
        "y": -0.5
      },
      "muzzleLateralOffset": -3.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 24,
        "y": 4,
        "width": 81,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 23,
        "width": 120,
        "height": 81
      },
      "centerOffset": {
        "x": 0,
        "y": -0.5
      },
      "muzzleLateralOffset": -3.5
    }
  },
  "p2-heavy-upgrade3": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 23,
        "y": 4,
        "width": 81,
        "height": 120
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 23,
        "width": 120,
        "height": 82
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -2
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 24,
        "y": 4,
        "width": 81,
        "height": 120
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 0
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 23,
        "width": 120,
        "height": 82
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -2
    }
  },
  "p2-heavy-upgrade4": {
    "up": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 23,
        "y": 4,
        "width": 82,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 1
    },
    "right": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 22,
        "width": 120,
        "height": 84
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -1.5
    },
    "down": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 23,
        "y": 4,
        "width": 82,
        "height": 120
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -1
    },
    "left": {
      "cellWidth": 128,
      "cellHeight": 128,
      "bounds": {
        "x": 4,
        "y": 22,
        "width": 120,
        "height": 84
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -1.5
    }
  },
  "boss-siege": {
    "up": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 18,
        "y": 0,
        "width": 61,
        "height": 83
      },
      "centerOffset": {
        "x": 0.5,
        "y": -6.5
      },
      "muzzleLateralOffset": 0.5
    },
    "right": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 19,
        "y": 20,
        "width": 77,
        "height": 57
      },
      "centerOffset": {
        "x": 9.5,
        "y": 0.5
      },
      "muzzleLateralOffset": -0.5
    },
    "down": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 17,
        "y": 13,
        "width": 61,
        "height": 83
      },
      "centerOffset": {
        "x": -0.5,
        "y": 6.5
      },
      "muzzleLateralOffset": -0.5
    },
    "left": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 0,
        "y": 20,
        "width": 77,
        "height": 57
      },
      "centerOffset": {
        "x": -9.5,
        "y": 0.5
      },
      "muzzleLateralOffset": -0.5
    }
  },
  "boss-hunter": {
    "up": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 23,
        "y": 8,
        "width": 50,
        "height": 80
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "right": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 8,
        "y": 23,
        "width": 80,
        "height": 50
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "down": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 23,
        "y": 8,
        "width": 50,
        "height": 80
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "left": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 8,
        "y": 23,
        "width": 80,
        "height": 50
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    }
  },
  "boss-bulwark": {
    "up": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 10,
        "y": 3,
        "width": 77,
        "height": 90
      },
      "centerOffset": {
        "x": 0.5,
        "y": 0
      },
      "muzzleLateralOffset": 1.5
    },
    "right": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 3,
        "y": 10,
        "width": 90,
        "height": 77
      },
      "centerOffset": {
        "x": 0,
        "y": 0.5
      },
      "muzzleLateralOffset": 1.5
    },
    "down": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 9,
        "y": 3,
        "width": 77,
        "height": 90
      },
      "centerOffset": {
        "x": -0.5,
        "y": 0
      },
      "muzzleLateralOffset": -1.5
    },
    "left": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 3,
        "y": 10,
        "width": 90,
        "height": 77
      },
      "centerOffset": {
        "x": 0,
        "y": 0.5
      },
      "muzzleLateralOffset": 1.5
    }
  },
  "boss-sniper": {
    "up": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 27,
        "y": 5,
        "width": 42,
        "height": 86
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "right": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 5,
        "y": 27,
        "width": 86,
        "height": 42
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    },
    "down": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 27,
        "y": 5,
        "width": 42,
        "height": 86
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": -0.5
    },
    "left": {
      "cellWidth": 96,
      "cellHeight": 96,
      "bounds": {
        "x": 5,
        "y": 27,
        "width": 86,
        "height": 42
      },
      "centerOffset": {
        "x": 0,
        "y": 0
      },
      "muzzleLateralOffset": 0.5
    }
  }
} as const satisfies Record<string, Record<Direction, SpriteFrameMetrics>>;

export function spriteMetricKeyForTank(tank: Pick<TankEntity, 'team' | 'kind' | 'playerNum' | 'upgradeLevel' | 'bossVariant' | 'playerTankClass'>): SpriteMetricKey {
  if (tank.team === 'player') {
    if (tank.playerTankClass && tank.playerTankClass !== 'standard') {
      const playerPrefix = tank.playerNum === 2 ? 'p2' : 'p1';
      return `${playerPrefix}-${tank.playerTankClass}-upgrade${tank.upgradeLevel}` as SpriteMetricKey;
    }
    if (tank.upgradeLevel > 1) return (tank.playerNum === 2 ? `p2upgrade${tank.upgradeLevel}` : `upgrade${tank.upgradeLevel}`) as SpriteMetricKey;
    return tank.playerNum === 2 ? 'p2' : 'p1';
  }
  if (tank.kind === 'boss') return `boss-${tank.bossVariant ?? 'siege'}` as SpriteMetricKey;
  if (tank.kind === 'heavy') return 'heavy';
  if (tank.kind === 'sniper') return 'sniper';
  if (tank.kind === 'assault') return 'assault';
  return 'light';
}

export function getSpriteMuzzleLateralOffset(tank: Pick<TankEntity, 'team' | 'kind' | 'playerNum' | 'upgradeLevel' | 'bossVariant' | 'playerTankClass' | 'direction' | 'size'>): number {
  const key = spriteMetricKeyForTank(tank);
  const metric = SPRITE_METRICS[key]?.[tank.direction];
  if (!metric) return 0;
  const renderSize = getSpriteRenderSize(tank);
  const lateralCellSize = tank.direction === 'up' || tank.direction === 'down' ? metric.cellWidth : metric.cellHeight;
  return metric.muzzleLateralOffset * (renderSize / lateralCellSize);
}

export function getSpriteRenderSize(tank: Pick<TankEntity, 'team' | 'kind' | 'upgradeLevel' | 'size'>): number {
  const upgradeScale = tank.team === 'player' ? Math.max(0, tank.upgradeLevel - 1) * 0.045 : 0;
  return tank.kind === 'boss' ? tank.size * 1.72 : tank.size * (1.78 + upgradeScale);
}
